import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { bindHandlers } from '../../../utils/common'
import { default as ButtonComponent } from '../../Button'

import { ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_DEFAULT } from './EntityProfileHeaderInfoItemActions.constants'

function EntityProfileHeaderInfoItemActions({
  actions = ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_DEFAULT,
  actionsWrapperClassName,
  buttonsProps,
  className,
  contentExist,
  handlers,
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.top,
  value,
}) {
  const { t } = useTranslation()

  return actions ? (
    <div className={actionsWrapperClassName}>
      {actions.map(
        ({ Button = ButtonComponent.Outlined, key, props, show }) => {
          const bound = handlers?.[key] && bindHandlers(handlers[key], value)

          if (show(contentExist)) {
            return (
              <Button
                {...props}
                {...buttonsProps?.[key]}
                {...bound}
                className={buttonsProps?.[key]?.className || className}
                isGrey={buttonsProps?.[key]?.isGrey ?? true}
                key={key}
                tooltip={t(buttonsProps?.[key]?.tooltip || props.tooltip)}
                tooltipPlacement={tooltipPlacement}
              />
            )
          }
        }
      )}
    </div>
  ) : null
}

export default EntityProfileHeaderInfoItemActions
